import React, {useState, createContext} from 'react';

export const PLDContext = createContext();

const PLDProvider = (props) => {
  const {children} = props;
  const [context, setContext] = useState({});

  function saveData(field, value) {
    context[field] = value;
    setContext({...context});
  }

  const mergeContext = (nuevasProps) => {
    setContext({ ...context, ...nuevasProps });
  }  

  return <PLDContext.Provider value={{context, saveData, mergeContext}}>{children}</PLDContext.Provider>;
};

export default PLDProvider;
